import { isSameDay, subDays } from 'date-fns'
import type { InAppNotification } from '../api/types'

export type NotificationDayGroupKey = 'today' | 'yesterday' | 'earlier'

export type NotificationDayGroup = {
  key: NotificationDayGroupKey
  notifications: InAppNotification[]
}

const GROUP_ORDER: NotificationDayGroupKey[] = ['today', 'yesterday', 'earlier']

const getDayGroupKey = (
  createdAt: string,
  now: Date
): NotificationDayGroupKey => {
  const date = new Date(createdAt)
  if (isSameDay(date, now)) return 'today'
  if (isSameDay(date, subDays(now, 1))) return 'yesterday'
  return 'earlier'
}

/** Regroupe la liste (déjà triée du plus récent au plus ancien) par jour, sans groupe vide. */
export const groupNotificationsByDay = (
  notifications: InAppNotification[],
  now: Date = new Date()
): NotificationDayGroup[] => {
  const byKey = new Map<NotificationDayGroupKey, InAppNotification[]>()
  for (const notification of notifications) {
    const key = getDayGroupKey(notification.createdAt, now)
    byKey.set(key, [...(byKey.get(key) ?? []), notification])
  }
  return GROUP_ORDER.filter((key) => byKey.has(key)).map((key) => ({
    key,
    notifications: byKey.get(key) ?? [],
  }))
}
